import resources from "constants/resources";
import { _fetch } from "./resources";
import { capitalize } from "utils/string";

export const updatePageRow = (resource, payload, matchKey = null) => ({
  type: "UPDATE_ROW",
  payload,
  resource,
  matchKey,
});


export const changeExistingPage = (resource, page) => ({
  type: "CHANGE_EXISTING_PAGE",
  page,
  resource
});

export const clearPagination = (resource) => ({
  type: "CLEAR_PAGINATION",
  resource
});

export const requestPage = (resource, payload) => ({
  type: "REQUEST_PAGE",
  resource,
  payload
});

export const receivePage = (resource, payload) => ({
  type: "RECEIVE_PAGE",
  resource,
  payload,
});

export const errorPage = (resource, error) => ({
  type: "ERROR_PAGE",
  resource,
  error
});

const fetchPage = _fetch(
  requestPage,
  receivePage,
  errorPage
);

export const paginators = {};

Object.keys(resources).forEach(key => {

  let resource = resources[key];
  paginators["fetchPaginated" + capitalize(resource.name)] = (id, page, params) => {
    return fetchPage(key, `${resource.url}/${id}/${page}`, params)
  };
  paginators["change" + capitalize(resource.name) + "ExistingPage"] = (page) => {
    return changeExistingPage(key, page)
  };
  paginators["clear" + capitalize(resource.name) + "Pagination"] = () => {
    return clearPagination(key)
  };
});






// WEBPACK FOOTER //
// ./src/actions/paginator.js